import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { flatMap, catchError } from 'rxjs/operators';
import { handleError } from '@src/shared/util-common';
import { environment } from '@src/environments/environment';

import { getHeaderNew } from '@src/core/base/header';
import { SucessoSessao } from './sessao.entity';

@Injectable({
  providedIn: 'root',
})
export class SessionDataRepository {

  constructor(private http: HttpClient) {
  }
  
  startUserSession(): Observable<SucessoSessao> {
    const httpOptions = {
      headers: getHeaderNew()
    };

    return this.http
      .get<SucessoSessao>(
        `${environment.URLBaseV3}sessao`,
        httpOptions
      )
      .pipe(flatMap((item) => [item]), catchError(handleError));

  }

}
